import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';
import { WinningPlanService } from '../../shared/services/winning-plan/winning-plan.service';

@Component({
  selector: 'vit-winning-plan',
  templateUrl: './winning-plan.component.html',
  styleUrls: ['./winning-plan.component.scss']
})
export class WinningPlanComponent implements OnInit {

    constructor(public sessionService: SessionService,
                public winningPlanService: WinningPlanService) {
  }

  ngOnInit() {
      this.winningPlanService.fetchWinningPlan();
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/menu-bar/winning-plan/winning-plan.component.ts